import Text from "@ingka/text";
import { useVideoMetadataFields } from "./hooks";
import RelatedAsset from "./RelatedAsset";
import { useStore } from "@/services/store";

type Props = {
  assetId: number;
  isLockedForOwner: boolean;
};

const RequiredFiles = ({ assetId, isLockedForOwner }: Props) => {
  const { shouldShowRequiredFiles, requiresCaption, requiresTranscript } =
    useVideoMetadataFields(assetId);
  const isVideoWithAudio = useStore(
    (state) => state.videoAssets[assetId]?.isVideoWithAudio,
  );

  if (!shouldShowRequiredFiles) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <Text tagName="h3" headingSize="xs" className="mb-space75">
        Required additional files
      </Text>
      {isVideoWithAudio && (
        <Text tagName="span" bodySize="s" className="mb-space50 font-bold">
          Does this video contain meaningful visuals and/or meaningful audio?
        </Text>
      )}
      <div className="flex flex-col gap-y-space50">
         {requiresTranscript && (
           <>
             {isVideoWithAudio && (
               <Text tagName="span" bodySize="s">
                 For meaningful visuals:
               </Text>
             )}
             <RelatedAsset
               assetId={assetId}
               languageSelectLabel="Select transcript language"
               uploadButtonLabel="Add transcript"
               validationMessageKey="transcript"
               fileUploadType="TRANSCRIPT"
               shouldValidate
               isLockedForOwner={isLockedForOwner}
             />
           </>
         )}
         {requiresCaption && (
           <>
             <Text tagName="span" bodySize="s">
               For meaningful audio:
             </Text>
             <RelatedAsset
               assetId={assetId}
               languageSelectLabel="Select caption language"
               uploadButtonLabel="Add caption"
               validationMessageKey="caption"
               fileUploadType="CAPTION"
               shouldValidate
               isLockedForOwner={isLockedForOwner}
             />
           </>
         )}
       </div>
     </div>
   );
};

export default RequiredFiles;
